<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="title">AGREEMENT DOCUMENTS</div>
      <el-table
        highlight-current-row
        class="table-wrap cqm-table"
        size="mini"
        :max-height="400"
        v-loading="allLoading"
        style="width: 100%"
        :data="list"
      >
        <el-table-column
          align="center"
          type="index"
          label=""
          width="50">
        </el-table-column>
        <el-table-column
          align="left"
          prop="fileName"
          :label="tableLable.fileName">
          <template slot-scope="scope">
            <span class="fileName-btn" @click="handleDownload(scope.row,1)">{{scope.row.fileName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="150"
          prop="uploadDate"
          :label="tableLable.uploadDate">
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          prop="fileLocationId"
          :label="tableLable.operation">
          <template slot-scope="scope">
            <span class="download-btn" @click="handleDownload(scope.row,0)">Download</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {api_agreement_list,api_order_confirm_download} from '@/api/api'
import {postAction,getAction,downFileGet} from '@/api/tool'
import Vue from 'vue'

export default {
  name:'Agreement',
  data() {
    return {
      show:false,
      list:[],
      tableLable:{
        fileName:'',
        uploadDate:'',
        operation:''
      } //表格的表头，因为这个地方切换语言的时候没办法正常渲染，所以需要监听语言包的变化，进行重新渲染
    }
  },
  watch:{
    L(newVal){
      this.tableLable=newVal
    }
  },
  methods:{
    handleDownload(obj,flag){
      let params = {
        filezIds:obj.fileLocationId
      }
      this.allLoading=true
      getAction(api_order_confirm_download,params).then(res=>{
        res.forEach((val)=>{
          let url='/'+val.split(Vue.config.YUNPAN_URL)[1]
          url=url.replace('PDF?','pdf?')
          downFileGet(url).then(res=>{
            this.allLoading=false
            this.downloadFile(res,flag)
          })
        })
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 获取客户列表 */
    getList(){
      this.allLoading=true
      postAction(api_agreement_list).then(res=>{
        this.allLoading=false
        this.list=res.ledProtocolList
      }).catch(()=>{
        this.allLoading=false
      })
    },
    open(){
      this.show=true
      this.getList()
    },
    close(){
      this.show=false
    }
  },
  mounted(){
    this.tableLable=this.L
  }
}
</script>

<style lang="less" scoped>
@import url('../../public/css/public.less');
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    // background-color: red;
    border-radius: 2px;
    position: absolute;
    // &:extend(.main-box-shadow);
    width:720px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding:30px 40px;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .title{
      font-size: 16px;
      font-weight: 600;
      color:@mainColor;
    }
    .table-wrap{
      margin-top: 20px;
      /* 表格外观走全局公共类 .cqm-table(public/css/public2.less)，此处只留本弹窗专有的下载按钮样式 */
      .fileName-btn{
        &:hover{
          cursor: pointer;
          color:@mainColor;
        }
      }
      .download-btn{
        color:@mainColor;
        &:hover{
          cursor: pointer;
        }
      }
    }
  }
}

</style>